import * as React from 'react';

import * as styles from './LocationModalContent.css';

interface ILocationModalContentProps {
  children?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export const LocationModalContent: React.FC<ILocationModalContentProps> = ({ children, ref }) => {
  return (
    <div className={styles['content-wrapper']} ref={ref}>
      <ul role="listbox" className={styles['list']}>
        {children}
      </ul>
    </div>
  );
};
